module.exports = __webpack_public_path__ + "img/notification.fe7caf41.png";